var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"edit-template-form-page"},[_c('iframe',{staticStyle:{"height":"100%","width":"100%"},attrs:{"src":_vm.templateUrl}})])
}
var staticRenderFns = []

export { render, staticRenderFns }